var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 14.6686 0.268629 14.4 0.6 14.4H29.4C29.7314 14.4 30 14.6686 30 15C30 15.3314 29.7314 15.6 29.4 15.6H0.599999C0.268629 15.6 0 15.3314 0 15Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C14.6686 30 14.4 29.7314 14.4 29.4V0.599999C14.4 0.268629 14.6686 0 15 0C15.3314 0 15.6 0.268629 15.6 0.6V29.4C15.6 29.7314 15.3314 30 15 30Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6066 25.6066C25.3723 25.8409 24.9924 25.8409 24.7581 25.6066L4.3934 5.24192C4.15909 5.00761 4.15909 4.62771 4.3934 4.39339C4.62772 4.15908 5.00761 4.15908 5.24193 4.39339L25.6066 24.7581C25.8409 24.9924 25.8409 25.3723 25.6066 25.6066Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6066 4.39339C25.8409 4.6277 25.8409 5.0076 25.6066 5.24192L5.24193 25.6066C5.00761 25.8409 4.62772 25.8409 4.3934 25.6066C4.15909 25.3723 4.15909 24.9924 4.3934 24.7581L24.7581 4.39339C24.9924 4.15907 25.3723 4.15907 25.6066 4.39339Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesign);
export default __webpack_public_path__ + "static/media/icon-design.35b7f53d87a28dd035d1e66250e8e133.svg";
export { ForwardRef as ReactComponent };